import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { findAll } from 'highlight-words-core';
export const highlightSearchTerm = (label, searchTerm) => {
  const chunks = findAll({
    searchWords: searchTerm.split(' '),
    textToHighlight: label,
    autoEscape: true
  });
  return chunks.map((chunk, i) => {
    const {
      end,
      highlight,
      start
    } = chunk;
    const text = label.substr(start, end - start);
    if (highlight) {
      return _jsx("mark", {
        children: text
      }, i);
    }
    return text;
  });
};